export const DISPLAY_STATUSES = {
    VISIBLE: 'visible',
    HIDDEN: 'hidden',
} as const;

export const ERROR_CODES = {
    invalidEmailDomain: 'invalid_email_domain_create_role',
    overdraft: 'overdraft',
} as const;
